import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Gift, Star, Award, Zap, Users, TrendingUp } from "lucide-react";

const PartnerPrivilege = () => {
  const benefits = [
    {
      icon: Star,
      title: "Priority Support",
      description: "Get dedicated support from our team with faster response times.",
    },
    {
      icon: Award,
      title: "Exclusive Rates",
      description: "Access special pricing on premium distribution channels.",
    },
    {
      icon: Zap,
      title: "Early Access",
      description: "Be the first to try new features and distribution networks.",
    },
    {
      icon: Users,
      title: "Partner Network",
      description: "Connect with other PR professionals and agencies.",
    },
    {
      icon: TrendingUp,
      title: "Analytics Plus",
      description: "Advanced analytics and reporting for your campaigns.",
    },
    {
      icon: Gift,
      title: "Bonus Credits",
      description: "Earn bonus credits on every successful distribution.",
    },
  ];

  return (
    <div className="space-y-6 max-w-4xl mx-auto animate-fade-in">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-heading font-bold text-slate-900">
            Partner Privilege
          </h1>
          <p className="text-slate-600 mt-1">
            Exclusive benefits for our valued partners
          </p>
        </div>
        <Badge className="bg-amber-100 text-amber-700 border-amber-200">
          Premium
        </Badge>
      </div>

      {/* Hero Card */}
      <Card className="bg-gradient-to-br from-slate-900 to-slate-800 text-white border-0">
        <CardContent className="p-8">
          <div className="flex items-center gap-4 mb-6">
            <div className="bg-amber-500 p-3 rounded-xl">
              <Gift className="h-8 w-8 text-white" />
            </div>
            <div>
              <h2 className="text-2xl font-heading font-bold">Partner Program</h2>
              <p className="text-slate-400">Unlock exclusive benefits and grow your business</p>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-6 text-center">
            <div>
              <p className="text-3xl font-bold text-amber-500">30%</p>
              <p className="text-slate-400 text-sm">Average Savings</p>
            </div>
            <div>
              <p className="text-3xl font-bold text-amber-500">24/7</p>
              <p className="text-slate-400 text-sm">Priority Support</p>
            </div>
            <div>
              <p className="text-3xl font-bold text-amber-500">500+</p>
              <p className="text-slate-400 text-sm">Partner Agencies</p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Benefits Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {benefits.map((benefit, index) => (
          <Card key={index} className="hover:shadow-md transition-shadow">
            <CardHeader>
              <CardTitle className="text-base font-medium flex items-center gap-3">
                <div className="bg-blue-100 p-2 rounded-lg">
                  <benefit.icon className="h-5 w-5 text-blue-600" />
                </div>
                {benefit.title}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-slate-600">{benefit.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* CTA */}
      <Card>
        <CardContent className="p-8 text-center">
          <h3 className="text-xl font-heading font-semibold text-slate-900 mb-3">
            Ready to become a partner?
          </h3>
          <p className="text-slate-600 mb-6 max-w-md mx-auto">
            Join our partner program and start enjoying exclusive benefits today.
            No commitment required.
          </p>
          <div className="flex items-center justify-center gap-4">
            <Button variant="outline">Learn More</Button>
            <Button className="bg-blue-600 hover:bg-blue-700">Apply Now</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PartnerPrivilege;
